import React from "react";
import { ErrorTemplate } from "components/ErrorTemplate";
import { ServerError as ServerErrorData } from "helpers/Consts";
import { useTitleChange } from "hooks/useTitleChange";
export const ServerError = () => {
  useTitleChange();
  return <ErrorTemplate {...ServerErrorData} />;
};
